import React from "react";

import "../../styles/Footer.css";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTwitterSquare, faMedium, faTelegram} from '@fortawesome/free-brands-svg-icons'

import { HashLink } from 'react-router-hash-link';

const Footer = () => {
  return (
    <div className="px-4 container-fluid footer-container">
      <div className="row no-gutters">
        <div className="col-10 offset-1">
          <footer className="footer">
            <Container fluid>
              <Row className="align-items-center">
                <Col xs={12} sm={6} md={4} className="footer-column mt-0">
                  <p className="footer-column-text text-warning">Developer</p>
                  <a href="https://t.me/pauliax"
                     target="blank" rel="noopener noreferrer">
                    @pauliax
                  </a>
                  <a href="#top"
                     target="blank" rel="noopener noreferrer">
                    @Thunder on Discord
                  </a>
                  <a href="https://knowethereum.com"
                     target="blank" rel="noopener noreferrer">
                    KnowEthereum
                  </a>
                </Col>
                <Col xs={12} sm={6} md={4} className="footer-column mt-4 mt-sm-0 align-self-start">
                  <p className="footer-column-text text-warning">Information</p>
                  <HashLink to="/#howItWorks">How It Works</HashLink>
                  <HashLink to="/#getStarted">Get Started</HashLink>
                  <HashLink to="/#faq">FAQ</HashLink>
                </Col>
                <Col xs={12} md={4} className="footer-column-icons mt-4 mt-md-0">
                  <a href="https://t.me/niftyeggs" target="blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faTelegram} size="2x"/>
                  </a>
                  <a href="https://medium.com/@niftyeggs" target="blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faMedium} size="2x"/>
                  </a>
                  <a href="https://twitter.com/EggsNifty" target="blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faTwitterSquare} size="2x"/>
                  </a>
                </Col>
              </Row>
              <div className="footer-bottom">
                <p className="text-xs-center">
                  &copy; {new Date().getFullYear()} NiftyEggs.eth
                </p>
              </div>
            </Container>
          </footer>
        </div>
      </div>
    </div>
  )
};

export default Footer;
